module.exports = __webpack_public_path__ + "static/media/profiteam.9e7de172.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/About/Tracks/img/profiteam.svg
// module id = 250
// module chunks = 0